<i18n>
{
  "en": {
    "title": "Company Ethics & Sustainability 2017-2018",
    "description": "Company ethics must go beyond regulatory compliance. At Schneider Electric, we believe it’s our responsibility to conduct business ethically, sustainably, and responsibly. Learn about the company’s new human rights policies, guidelines for suppliers, and Principles of Responsibility. ",
    "companyPerformance": {
      "section": "Company Performance",
      "title": "Company Ethics",
      "ethics": {
        "txt1": {
          "p1": "We believe it is our responsibility to go beyond regulatory compliance. Both on a daily basis and within our long-term strategy, we conduct business ethically, sustainably, and responsibly. These principles are at the heart of Schneider Electric’s corporate governance."
        },
        "txt2": {
          "title": "Human rights and duty of vigilance",
          "p1": "To comply with the 2017 French law concerning the Corporate Duty of Care, Schneider Electric has implemented a plan to identify health and safety risks and prevent violations of human rights and environmental damage.",
          "p2": "This plan applies to the operations of the company and of the companies it controls, as well as to the operations of the subcontractors or suppliers with whom it maintains an established commercial relationship.",
          "p3": "A dedicated governance body, the Duty of Care Committee, was established in May 2017."
        },
        "vid1": {
          "title": "Duty of Care",
          "desc": "Maxime Goualin, Business Ethics & Human Rights Manager, Schneider Electric"
        },
        "txt3": {
          "title": "Sustainable subcontractors and suppliers",
          "span1": "Since 2004, we’ve been encouraging suppliers to commit to a sustainable development initiative, and since 2012, Schneider Electric has been encouraging its ",
          "span2": "to make progress according to the ISO 26000 guidelines. Schneider Electric’s <a class='t-green-light' href='http://www2.schneider-electric.com/documents/sustainable-development-and-foundation/en/schneider-electric-supplier-guidebook-2016-15.pdf' target='_blank'>Supplier Guide Book</a> includes a large section on expectations with regard to sustainable development in the following five areas: health and safety, human rights, ethics, the environment, and sustainable purchasing.",
          "link1": "suppliers"
        },
        "txt4": {
          "title0": "Anti-corruption at Schneider Electric",
          "p1": "At Schneider Electric, we encourage our employees to conduct business ethically by adopting a zero-tolerance policy toward corruption and other unethical practices. To promote and develop integrity in business activities, various anti-corruption initiatives have been created or reinforced over the last few years, both in terms of prevention and control.",
          "p2": "This year, we’ve launched a new anti-corruption e-learning program which is mandatory for employees in the most exposed functions (finance, sales, and procurement) and we are tracking the results through the ",
          "p2-link": "Schneider Sustainability Impact.",
          "p2-1": "In addition, we launched an anti-corruption certification process for our Middle-East zone with the consulting company ETHIC Intelligence and are expected to be certified in 2018.",
          "p3": "We are also continuing our partnership with Transparency International France, a leading NGO which aims to stop corruption and promote transparency, responsibility, and integrity at all levels and across all sectors.",
          "title": "Principles of Responsibility",
          "span1": "Updated regularly, our <a class='t-green-light' href='http://www2.schneider-electric.com/documents/sustainable-development/ethics/our-principles-of-responsibility-2013.pdf' target='_blank'>Principles of Responsibility</a> document details Schneider Electric’s commitments to its employees, partners, shareholders, planet, and society. The next update is scheduled for later this year. The document aligns with the 10 principles of the Global Compact of the United Nations, the Universal Declaration of Human Rights, and standards issued by the International Labor Organization and the Organization for Economic Cooperation and Development."
        },
        "txt5": {
          "title": "Responsibility &amp; Ethics Dynamics program",
          "p1": "The Responsibility &amp; Ethics Dynamics (R&amp;ED) program includes processes and tools to foster employee compliance with our Principles of Responsibility. The program provides a safe, welcoming way for employees to help ensure compliance, and provides a structure of accountability by fostering reporting of non-compliance."
        },
        "snapshot1": {
          "title": "The R&amp;ED Line",
          "p1": "When an employee is a victim of or witness to an event that touches on ethical issues, a professional alert system has been available since 2012 to report information on such events. This system ensures the confidentiality of the exchanges and protects the anonymity of the whistleblower (unless there is legislation to the contrary).",
          "cell1": {
            "title": "259",
            "p1": "ethical alerts were escalated in the R&amp;ED line system in 2016"
          },
          "cell2": {
            "title": "46%",
            "p1": "of these alerts were related to potential violations of our code of conduct concerning integrity in financial matters"
          },
          "cell3": {
            "title": "35%",
            "p1": "of these alerts were related to allegations of discrimination, harassment, or unfair treatment of employees"
          },
          "cell4": {
            "title": "19%",
            "p1": "of these alerts were related to potential violation of other policies"
          }
        },
        "barometer": {
          "title": "2015 – 2017 Planet <span class='t-nowrap'>&amp; Society</span> barometer achievements",
          "cta": "See the full results",
          "one": {
            "title": "Ethics",
            "stat": "87.9%",
            "body": "of our recommended suppliers embrace ISO 26000 guidelines"
          },
          "two": {
            "title": "Ethics",
            "stat": "98.4%",
            "body": "All of entities pass our internal Ethics & Responsibility assessment"
          }
        }
      }
    }
  },
  "fr": {
    "title": "Éthique",
    "description": "Company ethics must go beyond regulatory compliance. At Schneider Electric, we believe it’s our responsibility to conduct business ethically, sustainably, and responsibly. Learn about the company’s new human rights policies, guidelines for suppliers, and Principles of Responsibility.",
    "companyPerformance": {
      "section": "Performance de l'Entreprise",
      "title": "Éthique",
      "ethics": {
        "txt1": {
          "p1": "Nous estimons que notre responsabilité va au-delà du respect des réglementations. Éthique, durabilité et responsabilité sont les maîtres-mots qui guident nos actions quotidiennes comme notre stratégie de long terme. Ces principes sont inscrits au cœur de la gouvernance d'entreprise de Schneider Electric."
        },
        "txt2": {
          "title": "Droits humains  et devoir de vigilance",
          "p1": "Conformément à la loi de 2017 relative au devoir de vigilance des sociétés mères et entreprises donneuses d’ordre, Schneider Electric a mis en place un plan visant à identifier les risques liés à la santé et à la sécurité et à prévenir les atteintes envers les droits humains et l’environnement.",
          "p2": "Ce plan s'applique aux activités de la société et des sociétés qu’elle contrôle, ainsi qu’aux activités des sous-traitants ou fournisseurs avec lesquels est entretenue une relation commerciale établie.",
          "p3": "Un organe de gouvernance dédié, le Comité Devoir de vigilance, a été créé en mai 2017."
        },
        "vid1": {
          "title": "Devoir de vigilance",
          "desc": "Maxime Goualin, Responsable Éthique et droits humains, Schneider Electric"
        },
        "txt3": {
          "title": "Sous-traitants et fournisseurs responsables",
          "span1": "Depuis 2004, Schneider Electric incite ses ",
          "span2": "à s’engager dans une initiative de développement durable, et depuis 2012, les encourage à progresser dans le respect des lignes directrices de la norme ISO 26000. Le <a class='t-green-light' href='http://www2.schneider-electric.com/documents/sustainable-development-and-foundation/en/schneider-electric-supplier-guidebook-2016-15.pdf' target='_blank'>Supplier Guide Book</a>, à l’intention des fournisseurs, comprend toute une section sur les attentes en matière de développement durable, selon cinq axes : santé et sécurité, droits humains, éthique, environnement et achats durables.",
          "link1": "fournisseurs"
        },
        "txt4": {
          "title0": "La luttre contre la corruption chez Schneider Electric",
          "p1": "Chez Schneider Electric, nous encourageons nos employés à agir de manière éthique et responsable en adoptant une politique de zéro tolérance en matière de corruption ou toute autre pratique non conforme à nos principes. Afin de promouvoir nos valeurs d’intégrité dans la manière dont nous conduisons nos activités, plusieurs initiatives ont été créées ou renforcées ces dernières années, aussi bien en matière de prévention que de contrôle. À titre d’exemple, en 2018 nous avons déployé un nouveau module de formation en ligne dédié à la lutte contre la corruption pour les fonctions les plus exposées (finance ; achat ; vente) dont les résultats sont mesurés dans le Schneider Sustainability Impact. En parallèle nous avons lancé une certification anti-corruption pour nos entités situées au Moyen-Orient avec la société de conseil Ethic Intelligence et espérons être certifié dès cette année. Nous continuons également notre partenariat avec Transparency International France, ONG leader en matière de lutte contre la corruption et de promotion de la transparence, de la responsabilité et de l’intégrité à tous les niveaux et dans tous les secteurs d’activité.",
          "title": "Les Principes de Responsabilité",
          "span1": "Régulièrement mis à jour, le document exposant nos <a class='t-green-light' href='http://www2.schneider-electric.com/documents/sustainable-development/ethics/our-principles-of-responsibility-2013.pdf' target='_blank'>\"Principes de Responsabilité\"</a> détaille les engagements de Schneider Electric vis-à-vis de ses collaborateurs, de ses partenaires économiques, de ses actionnaires, de la planète et de la société. La prochaine mise à jour devrait avoir lieu dans le courant de l’année. Ce document s’inspire des 10 principes du Pacte mondial des Nations unies, de la Déclaration universelle des droits de l’homme, ainsi que des normes établies par l’Organisation Internationale du Travail et l’Organisation de coopération et de développement économiques."
        },
        "txt5": {
          "title": "Le programme R&amp;ED (Responsibility &amp; Ethics Dynamics)",
          "p1": "Notre programme <em>Responsibility &amp; Ethics Dynamics</em> (programme R&amp;ED) comprend des processus et des outils pour inciter les collaborateurs à se conformer à nos \"Principes de Responsabilité\". Ce programme permet aux collaborateurs de contribuer, de façon sûre et conviviale, au respect de la conformité, et offre un dispositif de responsabilisation qui favorise le signalement des comportements non éthiques."
        },
        "snapshot1": {
          "title": "La R&amp;ED Line",
          "p1": "Un système d'alerte professionnel est en place depuis 2012 pour que les collaborateurs victimes ou témoins d'un événement posant un problème éthique puissent signaler l'incident.  Ce système assure la confidentialité des échanges et protège l'anonymat du lanceur d'alerte (à moins que la législation y soit contraire).",
          "cell1": {
            "title": "259",
            "p1": "alertes ont été remontées via le système d'alerte R&amp;ED en 2016"
          },
          "cell2": {
            "title": "46%",
            "p1": "d’entre elles concernaient des violations potentielles de notre code de conduite portant sur des sujets financiers"
          },
          "cell3": {
            "title": "35%",
            "p1": "d’entre elles avaient trait à des cas potentiels de discrimination, de harcèlement ou d’iniquité de traitement"
          },
          "cell4": {
            "title": "19%",
            "p1": "d’entre elles se rapportaient à des violations potentielles d'autres politiques de Schneider Electric"
          }
        },
        "barometer": {
          "title": "Les résultats du baromètre Planète &amp; Société 2015 - 2017",
          "cta": "Tous les résultats",
          "one": {
            "title": "Ethique",
            "stat": "87,90%",
            "body": "de nos fournisseurs recommandés en ligne avec l'ISO 26 000"
          },
          "two": {
            "title": "Ethique",
            "stat": "98,40%",
            "body": "de nos entités passent avec succès notre évaluation interne d'Éthique et de Responsabilité"
          }
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('@/assets/img/company-performance/company-ethics-hero-lores.jpg')" :hiResSrc="require('@/assets/img/company-performance/company-ethics-hero.jpg')" chapter="06" :section="$t('companyPerformance.section')" :title="$t('companyPerformance.title')"/>

    <section class="m-b-120 l-section-pad l-bg-white">
      <Statement>
        <h3 v-html="$t('companyPerformance.ethics.txt1.p1')"></h3>
      </Statement>
    </section>

    <section class="m-b-120">
      <Txt class="m-b-32">
        <h2 id="dutyofcare" v-html="$t('companyPerformance.ethics.txt2.title')"/>
        <p v-html="$t('companyPerformance.ethics.txt2.p1')" />
        <p v-html="$t('companyPerformance.ethics.txt2.p2')" />
        <p v-html="$t('companyPerformance.ethics.txt2.p3')" />
      </Txt>

      <YouTubeVideo videoId="Yj3aF2ed_y4" :title="$t('companyPerformance.ethics.vid1.title')" :description="$t('companyPerformance.ethics.vid1.desc')" :preview="require('@/assets/img/thumbnails/SSDHighlightVideo_MaximeGoualin_Still.jpg')"/>
    </section>

    <hr>

    <section class="m-t-120 m-b-120">
      <Txt class="m-b-32">
        <h2 id="sustainablesubcontractors" class="m-b-35" v-html="$t('companyPerformance.ethics.txt3.title')"/>
        <p>
          <span v-html="$t('companyPerformance.ethics.txt3.span1')"></span>
          <router-link class="t-green-light" v-html="$t('companyPerformance.ethics.txt3.link1')" :to="{name: 'SustainableSolutions_SupplyChain'}"></router-link>
          <span v-html="$t('companyPerformance.ethics.txt3.span2')"></span>
        </p>
      </Txt>

      <ImageFull>
        <img src="@/assets/img/company-performance/company-ethics-imgfull-1.jpg" />
      </ImageFull>
    </section>

    <section class="m-t-120 m-b-120 l-section-pad l-bg-white">
      <Txt class="">
        <h2 id="anti-corruption" v-html="$t('companyPerformance.ethics.txt4.title0')"/>
        <p v-html="$t('companyPerformance.ethics.txt4.p1')"></p>
        <p v-if="$i18n.locale === 'en'">
          <span v-html="$t('companyPerformance.ethics.txt4.p2')"></span>
          <router-link v-html="$t('companyPerformance.ethics.txt4.p2-link')" :to="{name: 'Introduction_WorkIndex'}"></router-link>
          <span v-html="$t('companyPerformance.ethics.txt4.p2-1')"></span>
        </p>
        <p v-if="$i18n.locale === 'en'" v-html="$t('companyPerformance.ethics.txt4.p3')"></p>
        <h2 v-html="$t('companyPerformance.ethics.txt4.title')"/>
        <p>
          <span v-html="$t('companyPerformance.ethics.txt4.span1')"></span>
        </p>
      </Txt>
    </section>

    <section class="m-b-120 m-t-120">
      <Barometer>
        <h2 class="t-grey" slot="copy" v-html="$t('companyPerformance.ethics.barometer.title')"/>
        <CTA slot="copy" href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('companyPerformance.ethics.barometer.cta')" target="_blank"/>
        <BarometerIndicator class="col-xs-18 col-sm-9" color="#009530" :title="$t('companyPerformance.ethics.barometer.one.title')" :stat="$t('companyPerformance.ethics.barometer.one.stat')" :body="$t('companyPerformance.ethics.barometer.one.body')"/>
        <BarometerIndicator class="col-xs-18 col-sm-9" color="#009530" :title="$t('companyPerformance.ethics.barometer.two.title')" :stat="$t('companyPerformance.ethics.barometer.two.stat')" :body="$t('companyPerformance.ethics.barometer.two.body')"/>
      </Barometer>
    </section>

    <section class="m-b-50 m-t-120 l-section-pad l-bg-white">
      <TxtMedia class="m-b-80">
        <h2 id="redynamics" class="m-b-35" slot="main-content" v-html="$t('companyPerformance.ethics.txt5.title')" />
        <p slot="main-content" v-html="$t('companyPerformance.ethics.txt5.p1')" />
        <img v-if="$i18n.locale === 'en'" slot="sidebar" src="@/assets/img/company-performance/red_logo_en.jpg" alt="">
        <img v-if="$i18n.locale === 'fr'" slot="sidebar" src="@/assets/img/company-performance/R&ED_logo_EN_FR.jpg" alt="">
      </TxtMedia>
      <hr />
      <Snapshot class="">
        <div slot="above" class="m-t-80">
          <h2 id="redline" v-html="$t('companyPerformance.ethics.snapshot1.title')" />
          <p v-html="$t('companyPerformance.ethics.snapshot1.p1')"></p>
        </div>
        <SnapshotCard class="t-white" :double="true" bgc="#626469">
          <h4 class="" v-html="$t('companyPerformance.ethics.snapshot1.cell1.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.ethics.snapshot1.cell1.p1')"></p>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <h4 class="t-green-light" v-html="$t('companyPerformance.ethics.snapshot1.cell2.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.ethics.snapshot1.cell2.p1')"></p>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <h4 class="t-green-light" v-html="$t('companyPerformance.ethics.snapshot1.cell3.title')"></h4>
          <div class="t-hr"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.ethics.snapshot1.cell3.p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" :double="true" bgc="#3dcd58">
          <h4 class="" v-html="$t('companyPerformance.ethics.snapshot1.cell4.title')"></h4>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody" v-html="$t('companyPerformance.ethics.snapshot1.cell4.p1')"></p>
        </SnapshotCard>
      </Snapshot>
    </section>

   <div class="l-content">
      <FooterNav
        nextRoute="LookingAhead_Overview"
        prevRoute="CompanyPerformance_Leadership" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import References from '@/components/References'
import Reference from '@/components/Reference'
import YouTubeVideo from '@/components/YouTubeVideo'
import ImageFull from '@/components/ImageFull'
import TxtMedia from '@/components/TxtMedia'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'
import Barometer from '@/components/Barometer'
import BarometerIndicator from '@/components/BarometerIndicator'

export default {
  name: 'CompanyPerformance_CompanyEthics',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    References,
    Reference,
    YouTubeVideo,
    ImageFull,
    TxtMedia,
    Snapshot,
    SnapshotCard,
    Barometer,
    BarometerIndicator
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company-performance/company-ethics.vue